<template>
  <div>
    <catalog-table
      title="Staff"
      :tableHeaders="customerStaffHeaders"
      :tableData="staff"
      :tableFilters="customerStaffFilters"
      :propsToSearch="customerStaffSearchableProps"
      :actions="customerStaffActions"
    >
      <template slot="header">
        <md-button class="md-success" @click="addCustomerStaff">
          <span class="md-label">
            <md-icon class="material-icons">add</md-icon>
          </span>
          Agregar
        </md-button>
      </template>
    </catalog-table>
    <!-- -->
    <modal v-if="editModal" @close="editModalHide">
      <template slot="body">
        <staff-edit
          :customerId="this.customerId"
          :customerStaff="this.currentCustomerStaff"
          :title="editModalTitle"
          @close="editModalHide"
          @saved="updateCustomerStaff"
          @error="hideEdit"
        ></staff-edit>
      </template>
    </modal>
  </div>
</template>

<script>
import catalogService from "@/services/catalog";
import { CatalogTable } from "@/components/";
import { mapState } from "vuex";
import { Modal } from "@/components";
import StaffEdit from "./EditStaff";
import customerStaffTransformer from "@/transformers/catalog/customerStaff";
import { booleanToState } from "@/filters";

export default {
  name: "CustomerStaff",
  components: {
    CatalogTable,
    Modal,
    StaffEdit,
  },

  props: {
    customerId: Number,
  },

  data() {
    return {
      staff: [],
      editModal: false,
      currentCustomerStaff: {},
      editModalTitle: "Editar Staff",
      customerStaffHeaders: {
        name: "Nombre",
        lastName: "Apellido Paterno",
        mothersLastName: "Apellido Materno",
        typeStaffName: "Tipo",
      },
      customerStaffFilters: {
        isActive: booleanToState,
      },
      customerStaffSearchableProps: ["name"],
      customerStaffActions: [
        {
          icon: "edit",
          exe: this.editCustomerStaff,
        },
        {
          icon: "close",
          exe: this.deleteCustomerStaff,
        },
      ],
    };
  },
  methods: {
    editModalHide() {
      this.editModal = false;
    },
    editCustomerStaff(customerStaff) {
      this.editModalTitle = "Editar staff";
      this.currentCustomerStaff = customerStaff;
      this.editModal = true;
    },
    deleteCustomerStaff(customerStaff) {
      this.$confirmMessage(
        { title: `¿Está seguro que desea borrar ${customerStaff.name}?` },
        () => {
          return catalogService
            .delete("customer/customerstaff", customerStaff)
            .then(() => {
              this.staff.splice(this.staff.indexOf(customerStaff), 1);
              this.$successMessage({
                title: `Miembro del staff borrado: ${customerStaff.name}`,
              });
            })
            .catch(this.$fireErrorResponse);
        }
      );
    },
    updateCustomerStaff({ original, updated }) {
      this.hideEdit();
      if (!original.id) {
        catalogService
          .create("customer/customerstaff", updated)
          .then((customerStaff) => {
            this.staff.push(customerStaff);
            this.$successMessage({
              title: `Creado nuevo staff: ${customerStaff.name}`,
            });
          })
          .catch(this.$fireErrorResponse);
      } else {
        catalogService
          .update("customer/customerstaff", updated, original)
          .then((customerStaff) => {
            this.staff.splice(this.staff.indexOf(original), 1, customerStaff);
            this.$successMessage({
              title: `${customerStaff.name} fue actualizado.`,
            });
          })
          .catch(this.$fireErrorResponse);
      }
    },
    addCustomerStaff() {
      this.editModalTitle = "Agregar staff";
      this.currentCustomerStaff = {};
      this.editModal = true;
    },
    hideEdit() {
      this.editModal = false;
    },
    getTypeCustomerStaff(id) {
      return this.typecustomerstaff.filter((tCS) => tCS.id == id)[0];
    },
  },
  computed: {
    ...mapState("catalogs", {
      //   customerstaff: s => s.customerstaff
      typecustomerstaff: (s) => s["customer/typecustomerstaff"],
    }),
  },
  mounted() {
    catalogService
      .fetch("customer/customerstaff/getstaff", {
        noStore: true,
        id: this.customerId,
        collection: true,
        config: {
          params: {
            expand: true,
          },
        },
        transformer: customerStaffTransformer,
      })
      .then((staff) => {
        this.staff = staff;
      });
    catalogService.fetch("customer/typecustomerstaff", { useStore: true });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Customers/Staff.vue